import { useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Spinner,
  Row,
} from "reactstrap";
import { apiURL1 } from '../../config';
import logo from "../../assets/img/brand/logo.png";

const ForgotPassword = () => {
  const [loginData, setLoginData] = useState({ email: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginData.email) {
      toast.warn("Please enter your email");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${apiURL1}/forgetPassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: loginData.email }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success("Password reset link sent to your email");
      } else {
        toast.error(data.message || "Failed to send reset link");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardBody className="px-lg-5 py-lg-5">
          <Row className="align-items-center justify-content-center mb-4">
            <Col xs="auto" className="px-2">
              <img width={"150px"} src={logo} className="mx-auto d-block" alt="Logo" />
            </Col>
          </Row>
          <div className="text-center text-muted mb-4">
            <small>Reset Your Password</small>
          </div>
          <Form onSubmit={handleSubmit}>
            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-email-83" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Email"
                  type="email"
                  name="email"
                  autoComplete="new-email"
                  value={loginData.email}
                  onChange={handleChange}
                />
              </InputGroup>
            </FormGroup>
            <div className="text-center">
              <Button className="my-4" color="danger" disabled={loading || !loginData.email}>
                {loading ? <Spinner size={"sm"} /> : "Reset"}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ForgotPassword;